module.exports = __webpack_public_path__ + "media/images/document-591a0a6a4a7e422423526e1000c026ba.png";